import {
  HolidayOrder,
  OrderStatus,
  OrderDetail,
  PassengerType,
  DocumentType,
  FlightType,
} from './types';

import {
  postApprovePaymentApi,
  CONFIRMED_STATUS,
  UNCONFIRMED_STATUS,
} from 'app/services/holidayApi';

export interface ApprovalResponse {
  success: boolean;
  message?: string;
  errorCode?: 'MSG021' | 'MSG022' | 'MSG023';
  data?: HolidayOrder;
}

export const approveOrderApi = async (
  idHash: string,
): Promise<ApprovalResponse> => {
  try {
    const form = new FormData();
    form.append('idHash', idHash);
    form.append('state', CONFIRMED_STATUS);
    form.append('type', 'holiday');

    const res: any = await postApprovePaymentApi(form);

    return {
      success: true,
      message: res?.message || 'Phê duyệt đơn hàng thành công',
      data: { id: idHash, subOrderState: OrderStatus.CONFIRMED } as any,
    };
  } catch (err: any) {
    // Map backend error to ApprovalResponse-like rejection
    const errorCode = err?.response?.data?.code || err?.errorCode;
    const messageText = err?.response?.data?.message || err?.message || '';
    return Promise.reject({ success: false, errorCode, message: messageText });
  }
};

export const rejectOrderApi = async (
  idHash: string,
): Promise<ApprovalResponse> => {
  try {
    const form = new FormData();
    form.append('idHash', idHash);
    form.append('state', UNCONFIRMED_STATUS);
    form.append('type', 'holiday');

    const res: any = await postApprovePaymentApi(form);

    return {
      success: true,
      message: res?.message || 'Từ chối đơn hàng thành công',
      data: { id: idHash, subOrderState: OrderStatus.UNCONFIRMED } as any,
    };
  } catch (err: any) {
    const errorCode = err?.response?.data?.code || err?.errorCode;
    const messageText = err?.response?.data?.message || err?.message || '';
    return Promise.reject({ success: false, errorCode, message: messageText });
  }
};

